import { useRef } from 'react'

/**
 * @constructor {(string)=>void}
 */
export default class Validator {
  password = ''
  score = 0

  number = 0
  letter = {
    lower: 0,
    upper: 0
  }
  punctuation = 0
  whitespace = 0
  invalid = 0

  constructor(newPassword) {
    this.analyze(newPassword)
  }

  /**
   * @param {string} newPassword
   */
  analyze(newPassword) {
    this.password = newPassword || ''
    this.score = 0
    this.number = 0
    this.letter = {
      lower: 0,
      upper: 0
    }
    this.punctuation = 0
    this.whitespace = 0
    this.invalid = 0

    // 分析
    for (let index = 0; index < this.password.length; index++) {
      const c = this.password[index]
      if (/[a-z]/.test(c)) this.letter.lower++
      else if (/[A-Z]/.test(c)) this.letter.upper++
      else if (/\d/.test(c)) this.number++
      else if (/ /.test(c)) this.whitespace++
      else if (/[\p{P}$+<=>^`|~]/gu.test(c)) this.punctuation++
      else this.invalid++
    }

    this.scoring()
  }

  scoring() {
    // length
    if (this.password.length >= 8) this.score += 25
    else if (this.password.length >= 5) this.score += 10

    // number
    if (this.number >= 3) this.score += 20
    else if (this.number) this.score += 10

    // letter
    if (this.letter.lower + this.letter.upper) {
      if (!(this.letter.lower && this.letter.upper)) this.score += 10
      else this.score += 20
    }

    // punctuation
    if (this.punctuation === 1) this.score += 10
    else if (this.punctuation > 1) this.score += 25

    // bounas
    if (
      this.punctuation &&
      this.number &&
      this.letter.lower &&
      this.letter.upper
    )
      this.score += 5
    else if (
      this.punctuation &&
      this.number &&
      this.letter.lower + this.letter.upper
    )
      this.score += 3
    else if (this.number && this.letter.lower + this.letter.upper)
      this.score += 2
  }

  /**
   * @param {string} newPassword
   */
  set(newPassword) {
    this.analyze(newPassword)
  }

  getScore() {
    return this.score
  }

  getRules() {
    return [
      this.password.length >= 8,
      !!(this.number && this.letter.lower + this.letter.upper),
      this.whitespace === 0
    ]
  }
}

/**
 * @return {Validator}
 */
export function useValidator() {
  const validator = useRef(null)

  if (!validator.current) {
    validator.current = new Validator()
  }
  return validator.current
}
